import * as React from "react";
import {SpinnerButton} from "shared/controls/SpinnerButton";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {faSearch} from "@fortawesome/free-solid-svg-icons/faSearch";
import {faCog} from "@fortawesome/free-solid-svg-icons/faCog";
import {faTimes} from "@fortawesome/free-solid-svg-icons/faTimes";
import {DocumentManager} from "../Manager/PDFManager/DocumentManager";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {TemplateSettings} from "../Dialogs/TemplateSettings/TemplateSettings";

export class TopBar extends React.Component<TopBarProps, TopBarState> {
    static defaultProps: Partial<TopBarProps> = {};

    constructor(props: TopBarProps) {
        super(props);
        this.state = {
            IsBusy:false,
            IsPreviewing:false
        };
    }

    public render() {
        return (
            <div style={{display:'flex',width:'100%',alignItems:'center',height:70,paddingRight:10}}>
                <div style={{padding:10}}>
                    <SpinnerButton className={'rnbtn rnbtn-success btnSaveTemplate'} IsBusy={this.state.IsBusy}  OnClick={()=>this.Save()}>Save</SpinnerButton>
                    <SpinnerButton Icon={<FontAwesomeIcon icon={faSearch}/>} className={'rnbtn rnbtn-info'} IsBusy={this.state.IsPreviewing} style={{marginLeft:5}} OnClick={()=>this.Preview()}>Preview</SpinnerButton>
                    <SpinnerButton Icon={<FontAwesomeIcon icon={faCog}/>} className={'rnbtn rnbtn-warning'} style={{marginLeft:5}} OnClick={()=>this.OpenTemplateSettings()}> Template Settings</SpinnerButton>
                </div>
                <div style={{flexGrow:1,paddingLeft:10,display:'inline-flex',alignItems:'center'}}>
                    <span style={{fontWeight:'bold',fontSize:20}}>Editing:</span>
                    <input style={{flexGrow:1,fontSize:30}} className={'calculatedFormName'} placeholder={'Please fill the name for your template'} value={this.props.DocumentManager.Options.TemplateName} onChange={x=>{this.props.DocumentManager.Options.TemplateName=x.target.value;this.forceUpdate()}}/>
                </div>
                <a
                    href={rnImporterVar.DesignerURL}
                    id={'ExitButton'}

                    style={{fontSize: 30, float: 'right',display:'flex',alignItems:'center'}}><FontAwesomeIcon icon={faTimes}/></a>
            </div>
        )
    }

    private async Save() {
        this.setState({IsBusy:true},async ()=>{
            setTimeout(async ()=>{
                await this.props.DocumentManager.Save();
                this.setState({IsBusy:false});
            },200)

        });


    }

    private OpenTemplateSettings() {
        Dialog.Show(<TemplateSettings DocumentManager={this.props.DocumentManager}/>);
    }


    async Preview(){
        this.setState({IsPreviewing:true});
        try {
            let rawData=await this.props.DocumentManager.GetPDFObjects();

            let formData=new FormData();
            formData.append('data',JSON.stringify({Template:rawData}));
            formData.append('action',rnImporterVar._prefix+'_LivePreview');
            formData.append('_nonce',(rnImporterVar as any)._nonce);

            let response=await fetch((rnImporterVar as any).ajaxurl,{
                method:'POST',
                body:formData
            });

            let blob=await response.blob();
            let url=URL.createObjectURL(new Blob([blob],{type:'application/pdf'}));
            window.open(url,'_blank');
        } finally {
            this.setState({IsPreviewing:false});
        }
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface TopBarProps {
    DocumentManager:DocumentManager;
}

interface TopBarState {
    IsBusy:boolean;
    IsPreviewing:boolean;
}

//#endregion "My Region"